import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";
import { ArrowBtn } from "../../../app-constants";

function Servicelisting(props) {
  return (
    <section className="p-100 pt-0">
      <Container>
        <>
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="seriveces_listing page_listing"
            >
              <div className="example" data-text="Primary">
                <h2>Primary Services</h2>
              </div>
            </Col>
          </Row>
          <Row>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Android App Development</h4>
                <p>
                  TekRevol has a team of experienced Android App Developers that
                  are ready to help you with your app idea.
                </p>
                <Link to="https://www.tekrevol.com/android-app-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>iOS App Development</h4>
                <p>
                  TekRevol develops next-gen iOS apps for businesses that ensure
                  market disruption, growth, and scalability.
                </p>
                <Link to="https://www.tekrevol.com/iphone-app-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Cross Platform App Development</h4>
                <p>
                  Partner with TekRevol to get the most out of your next app
                  project{" "}
                </p>
                <Link to="/cross-platform-app-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Custom Software Development</h4>
                <p>
                  Our custom software development services provide our clients
                  with the freedom to grow and scale
                </p>
                <Link to="https://www.tekrevol.com/custom-software-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Startup App Development</h4>
                <p>
                  We rely on our modernized core to help startups to bring their
                  app ideas to life
                </p>
                <Link to="/startup-app-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Flutter app development</h4>
                <p>
                  TekRevol is a full-scale flutter app development company that
                  build scalable mobile apps
                </p>
                <Link to="https://www.tekrevol.com/flutter-app-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Web Development</h4>
                <p>
                  Establish a strong digital presence with custom website design
                  and development services.
                </p>
                <Link to="https://www.tekrevol.com/web-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Game Development</h4>
                <p>
                  TekRevol is a leading mobile game development company that
                  develop high-quality mobile games
                </p>
                <Link to="https://www.tekrevol.com/game-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Mobile App Support</h4>
                <p>
                  Tekrevol provides result-orientated and efficient application
                  support and maintenance solution for after deployment.
                </p>
                <Link to="https://www.tekrevol.com/mobile-app-support">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Wearable App Development</h4>
                <p>
                  Explore the limitless possibilities with wearable technology
                  and expand your business through smarter, more efficient
                  solutions.
                </p>
                <Link to="/wearable-app-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Cloud Native Development</h4>
                <p>
                  Creating and delivering an innovative business experience to
                  your stakeholder.
                </p>
                <Link to="/cloud-native-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>IoT Development</h4>
                <p>
                  As a forward-thinking startup or enterprise, working on IoT
                  technology is a wise move.{" "}
                </p>
                <Link to="/iot-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>API Integration</h4>
                <p>
                  Scale the capabilities of your business solutions through
                  custom API development and integration services
                </p>
                <Link to="https://www.tekrevol.com/api-integration-service">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>E-Commerce Software Development</h4>
                <p>
                  Scale the capabilities of your business solutions through
                  custom API development and integration services
                </p>
                <Link to="/ecommerce-software-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Chatbot Development</h4>
                <p>Boost customer engagement and communication efforts 10x </p>
                <Link to="https://www.tekrevol.com/chatbot-development-company">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            {/* <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Mobile App Development Services</h4>
                <p>Looking for top-tier mobile app development services?</p>
                <Link to="/mobile-app-development-services">{ArrowBtn}</Link>
              </div>
            </Col> */}
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Mobile App Development</h4>
                <p>
                  Tekrevol is a mobile app development company that implements a
                  data-driven and disruptive approach to leverage technologies.
                </p>
                <Link to="https://www.tekrevol.com/mobile-app-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Magento Development Services</h4>
                <p>
                  As a leading Magento development agency, TekRevol offers
                  tailored solutions to promote your e-commerce venture.
                </p>
                <Link to="https://www.tekrevol.com/magento-development-services">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Enterprise App Development</h4>
                <p>
                  TekRevol stands as a top-grade enterprise app development
                  company, dedicated to propelling your business forward through
                  cutting-edge solutions.
                </p>
                <Link to="https://www.tekrevol.com/enterprise-app-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Wordpress Development</h4>
                <p>
                  As a renowned WordPress Development Company, TekRevol help you
                  to create an exceptional digital presence for your brand.
                </p>
                <Link to="/wordpress-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Unity Game App Development</h4>
                <p>
                  Struggling to find a Unity game development company you can
                  truly rely on? Look no further!
                </p>
                <Link to="/unity-game-app-development">{ArrowBtn}</Link>
              </div>
            </Col>
            {/* <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Unity Game Development</h4>
                <p>
                  TekRevol is a company that takes ideas and turns them into
                  award-winning games that are played across the globe by
                  millions.
                </p>
                <Link to="/unity-game-development">{ArrowBtn}</Link>
              </div>
            </Col> */}
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Unreal Engine Game Development</h4>
                <p>
                  Frustrated in your search for a dependable Unreal Engine game
                  development company?
                </p>
                <Link to="/unreal-engine-game-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Web Application Development</h4>
                <p>
                  Revitalize your online presence with our leading web app
                  development company,
                </p>
                <Link to="https://www.tekrevol.com/web-application-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Web3 Development Company</h4>
                <p>
                  We excel in creating interactive web 3.0 solutions using
                  blockchain, AI, and IoT technologies.
                </p>
                <Link to="/web3-development-company">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Saas Video Production</h4>
                <p>
                  We produce thought-provoking SaaS explainer videos that are
                  engaging, and creative.
                </p>
                <Link to="/saas-video-production">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Hire .Net Developer</h4>
                <p>
                  TekRevol is a premier marketplace connecting you with the
                  industry's top .NET developers and coders.
                </p>
                <Link to="/hire-dot-net-developers">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Hire IOS App Developers</h4>
                <p>
                  Transform your business with expert iOS app developers,
                  available for freelance and full-time roles.
                </p>
                <Link to="/hire-ios-app-developers">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Hire Android App Developers</h4>
                <p>
                  Upscale your business with highly skilled Android app
                  developers available for full-time and hybrid roles.
                </p>
                <Link to="/hire-android-app-developers">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Hire Reactjs App Developers</h4>
                <p>
                  TekRevol provides unparalleled assistance in sourcing and
                  hiring elite React developers for freelance and full-time
                  positions.
                </p>
                <Link to="/hire-reactjs-developers">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Ecommerce Website Development</h4>
                <p>
                  Build mobile-ready, user-first shopping solutions with your
                  favorite eCommerce store.
                </p>
                <Link to="https://www.tekrevol.com/ecommerce-website-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Web3 Game Development</h4>
                <p>
                  TekRevol uses talent and technology to help game and media
                  startups develop and launch Web3 games three times faster.
                </p>
                <Link to="/web3-game-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Web Portal Development</h4>
                <p>
                  TekRevol has transformed visionary concepts into fully
                  functional, user-friendly web portals for 5+ years.
                </p>
                <Link to="/web-portal-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Digital Marketing Services</h4>
                <p>
                  Our agency helps businesses with channel selection, integrated
                  communications, and brand building to tackle online
                  challenges.
                </p>
                <Link to="https://www.tekrevol.com/digital-marketing-agency">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Logistic App Development</h4>
                <p>
                  Conceptualize, design, and code high-end, feature-rich
                  applications with our logistics app development company.
                </p>
                <Link to="/logistic-app-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Retail App Development</h4>
                <p>
                  Upgrade your retail business with custom apps designed to
                  streamline operations and boost sales.
                </p>
                <Link to="/retail-app-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Telecom Software</h4>
                <p>
                  Unlock next-gen connectivity with telecom software using AI
                  and cloud-native tech for superior performance and
                  reliability.
                </p>
                <Link to="/telecom-software-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Construction Software</h4>
                <p>
                  Construction businesses face budget overruns and operational
                  bottlenecks, leading to stalled progress and expensive project
                  delays.
                </p>
                <Link to="/construction-software-development">{ArrowBtn}</Link>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="seriveces_listing page_listing"
            >
              <div className="example" data-text="Consulting">
                <h2>Consulting Services</h2>
              </div>
            </Col>

            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Cloud Computing</h4>
                <p>
                  Cloud technology makes it possible to build excellent IT
                  infrastructure
                </p>
                <Link to="https://www.tekrevol.com/cloud-consulting-services">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>CTO Consultant</h4>
                <p>
                  Work with C-level tech executives to experience fundamental
                  digital transformation.
                </p>
                <Link to="/cto-consultant">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Emerging Technology</h4>
                <p>
                  TekRevol delivers world-class enterprise emerging technology
                  solution{" "}
                </p>
                <Link to="/emerging-technology-solutions">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Digital Transformation</h4>
                <p>
                  As premier digital transformation consultants, our digital
                  transformation services provide our clients{" "}
                </p>
                <Link to="/digital-transformation-company">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Digital Marketplace</h4>
                <p>
                  Create fully-featured online niche marketplaces, attract
                  relevant global traffic
                </p>
                <Link to="/digital-marketplace">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Data Analytics</h4>
                <p>
                  TekRevol’s big data analytics services are designed for
                  enterprise organizations.
                </p>
                <Link to="/data-analytics-solutions">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Digital Strategy</h4>
                <p>
                  Our digital strategy consulting services are user-centric
                  digitalized concepts{" "}
                </p>
                <Link to="/digital-strategy-consultant">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Ip Protection</h4>
                <p>
                  Protecting Intellectual Property can be an incredibly
                  expensive, time consuming and complex task.
                </p>
                <Link to="/ip-protection">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Technology Consulting</h4>
                <p>
                  Our tech consulting services encompass all the modern aspects
                </p>
                <Link to="/technology-consulting">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>MVP Software Development</h4>
                <p>
                  TekRevol is experienced in designing, developing, and
                  launching minimum viable products
                </p>
                <Link to="/mvp-software-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Managing Mobility</h4>
                <p>
                  Tekrevol helps you set up the architecture, build mobility
                  systems
                </p>
                <Link to="/managing-mobility">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Lean Startup Plan</h4>
                <p>
                  Our lean startup services enable startups to find the right
                  areas that impact consumers
                </p>
                <Link to="/lean-startup-plan">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Research and Development</h4>
                <p>
                  TekRevol is a technology research and development company
                  working to improve existing services
                </p>
                <Link to="/research-development-company">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Startup Prototype</h4>
                <p>
                  Discover the potential of your product idea with a pioneering
                  Startup Prototype Development Company.
                </p>
                <Link to="/startup-prototype">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Managed Cloud Services</h4>
                <p>
                  Our cloud-managed services help your business evolve digitally
                  by utilizing modern cloud computing.
                </p>
                <Link to="/managed-cloud-services">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Cloud Application Development</h4>
                <p>
                  To drive intelligent business decisions, you need cloud-based
                  application development.
                </p>
                <Link to="https://www.tekrevol.com/cloud-application-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Serverless Computing Services</h4>
                <p>
                  Our serverless computing services are designed to help your
                  business.
                </p>
                <Link to="/serverless-computing-services">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Infrastructure Migration Services</h4>
                <p>
                  The team at Tekrevol comes in handy if you are looking for
                  state-of-the-art infrastructure migration services.
                </p>
                <Link to="/infrastructure-migration-services">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Cloud Migration</h4>
                <p>
                  TekRevol's cloud migration services help businesses seamlessly
                  transition applications and databases to the cloud with
                  precision and efficiency.
                </p>
                <Link to="https://www.tekrevol.com/cloud-migration">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Devops Enablement</h4>
                <p>
                  Empower your teams with a cutting-edge framework for DevOps
                  Enablement that ensures high-quality software development.
                </p>
                <Link to="/devops-enablement">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Cloud Cost Optimization</h4>
                <p>
                  Balance your budget with deeper insights of cloud optimization
                  and build a strategy that optimizes the overall workflow by
                  streamlining the operations.
                </p>
                <Link to="/cloud-cost-optimization">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Cloud Infrastructure</h4>
                <p>
                  Get a robust and agile cloud infrastructure for your business
                  to stay competitive and innovative.
                </p>
                <Link to="/cloud-infrastructure">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Cloud Support And Maintenance</h4>
                <p>
                  TekRevol helps its clients future-proof their digital
                  transformation journey with cloud support and maintenance
                  services.
                </p>
                <Link to="/cloud-support-and-maintenance">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>SEO</h4>
                <p>
                  Build your website’s authority with promising results
                  following our proven SEO strategy.
                </p>
                <Link to="https://www.tekrevol.com/search-engine-optimization">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Woocommerce Development Services</h4>
                <p>
                  Get your WooCommerce site up and running with our expert team.
                </p>
                <Link to="/woocommerce-development-services">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Vendor Portal Development</h4>
                <p>
                  With 5+ years' experience, TekRevol’s vendor portals
                  streamline workflows and strengthen partnerships in one hub.
                </p>
                <Link to="/vendor-portal-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Ionic App Development</h4>
                <p>
                  TekRevol specializes in creating top-notch ionic applications
                  using open-source UI toolkits across different platforms.
                </p>
                <Link to="/ionic-app-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>B2B Portal Development</h4>
                <p>
                  B2B portal development creates an integrated platform for
                  efficient interactions among partners, suppliers, and buyers.
                </p>
                <Link to="/b2b-portal-development">{ArrowBtn}</Link>
              </div>
            </Col>
          </Row>
          <Row>
            <Col
              xs={12}
              md={12}
              lg={12}
              xl={12}
              xxl={12}
              className="seriveces_listing page_listing"
            >
              <div className="example" data-text="Trending">
                <h2>Trending Services</h2>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>AI Development</h4>
                <p>
                  TekRevol is a leading AI software development company
                  laser-focused on building, training and deploying AI-based
                  algorithms.
                </p>
                <Link to="https://www.tekrevol.com/ai-development-company">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>AR/VR Company</h4>
                <p>
                  An AR/VR app development company to cater to next-gen digital
                  media enthusiasts.
                </p>
                <Link to="https://www.tekrevol.com/ar-vr-company">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Digital Strategy</h4>
                <p>
                  Our digital strategy consulting services are user-centric
                  digitalized concepts{" "}
                </p>
                <Link to="/digital-strategy-consultant">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Automation Consultancy</h4>
                <p>
                  Put the right talent, data, and intelligence into action for
                  business transformation.
                </p>
                <Link to="/automation-consultancy">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Bluetooth App Development</h4>
                <p>
                  Deliver low-consumption interactive experiences to your end
                  users through beacon-based digital products.
                </p>
                <Link to="/bluetooth-app-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>NFT Development</h4>
                <p>
                  TekRevol specializes in building blockchain ecosystems for
                  creating and managing NFTs.
                </p>
                <Link to="/nft-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Machine Learning</h4>
                <p>
                  Use ML solutions and establish stronger foundations for
                  effective business processes
                </p>
                <Link to="/machine-learning-company">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Blockchain Development</h4>
                <p>
                  We are a Blockchain development services provider to help
                  enterprises to acquire transparency and automation
                </p>
                <Link to="/blockchain-development-company">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>BlockChain App Development</h4>
                <p>
                  Lead the digital world by incorporating next-gen business
                  practices based on blockchain technology.
                </p>
                <Link to="/blockchain-app-development">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Metaverse Development</h4>
                <p>
                  Build your own shared and immersive experiences where players
                  and avatars can engage with each other
                </p>
                <Link to="/metaverse-development-company">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>DevOps Consultancy</h4>
                <p>
                  Accomplish your technical delivery objectives and create,
                  deploy and test your products and solutions faster.
                </p>
                <Link to="/devops-consultancy-services">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>React Native App Development</h4>
                <p>
                  Partner with TekRevol as your react native app development
                  company.
                </p>
                <Link to="https://www.tekrevol.com/react-native-app-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Generative AI</h4>
                <p>
                  Gen AI – a new accelerator in the transformative digital
                  landscape enables process automation and optimization.
                </p>
                <Link to="https://www.tekrevol.com/generative-ai">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Natural Language Processing</h4>
                <p>
                  Integrate Natural Language Processing solutions across core
                  operations.
                </p>
                <Link to="https://www.tekrevol.com/natural-language-processing-services">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Speech Recognition</h4>
                <p>
                  Accelerate data entry, minimize regular workload, and enhance
                  software accessibility with advanced voice technology
                  solutions from Belitsoft.
                </p>
                <Link to="/speech-recognition-software-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>App Store Optimization</h4>
                <p>
                  Turn app searches into downloads with targeted ASO services.
                </p>
                <Link to="https://www.tekrevol.com/app-store-optimization">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            {/* <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Agency Partnership Program</h4>
                <p>
                  Our team at TekRevol supports you at every phase of the
                  software development cycle.
                </p>
                <Link to="/partnership-program">{ArrowBtn}</Link>
              </div>
            </Col> */}
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Search Engine Marketing</h4>
                <p>
                  Get found by millions of potential prospects with custom,
                  high-impact search ads.
                </p>
                <Link to="https://www.tekrevol.com/search-engine-marketing">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Social Media Marketing</h4>
                <p>
                  Tekrevol provides top-tier social media marketing services
                  that ensure high engagement with your target audience.
                </p>
                <Link to="https://www.tekrevol.com/social-media-marketing-services">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>2D Game Development</h4>
                <p>
                  Our 2D game development services help you design interactive
                  environments with highly responsive functionalities.
                </p>
                <Link to="https://www.tekrevol.com/2d-game-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>3D Game Development</h4>
                <p>
                  TekRevol is a leading 3D game development company that
                  produces modern and attractive 2D and 3D games on iOS and
                  Android.
                </p>
                <Link to="https://www.tekrevol.com/3d-game-development">
                  {ArrowBtn}
                </Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Shopify Web Development</h4>
                <p>
                  Create a unique Shopify store with our secure, custom, and
                  SEO-optimized web development services.
                </p>
                <Link to="/shopify-development-services">{ArrowBtn}</Link>
              </div>
            </Col>
            <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
              <div className="item_listing">
                <h4>Progressive Web App</h4>
                <p>
                  TekRevol is a leading progressive web app development company
                  in developing unique PWAs tailored to your business needs.
                </p>
                <Link to="/progressive-web-app-development">{ArrowBtn}</Link>
              </div>
            </Col>
          </Row>
        </>
      </Container>
    </section>
  );
}

export default Servicelisting;
